// This component is based on the material-ui example - downshift (With Popper)
// See https://material-ui.com/demos/autocomplete and https://github.com/paypal/downshift

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Downshift from 'downshift'
import { withStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import TextField from '@material-ui/core/TextField'


const styles = theme => ({
  highlightedMenuItem: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: '#fff !important'
  }
})

class Autocomplete extends Component {
  popperNode = null

  renderInput(inputProps) {
    const {InputProps, ref, ...other} = inputProps
    return (
      <TextField
        InputProps={{
          inputRef: ref,
          ...InputProps
        }}
        {...other}
      />
    )
  }

  renderItem({classes, highlightedIndex, index, item, itemProps}) {
    const isHighlighted = highlightedIndex === index
    return (
      <MenuItem
        classes={{selected: classes.highlightedMenuItem}}
        component="div"
        key={item.sessionId}
        selected={isHighlighted}
        style={{
          fontWeight: 400,
          color: 'black'
        }}
        {...itemProps}
      >
        {`${item.caseId} - ${item.decisionName}`}
      </MenuItem>
    )
  }

  render() {
    const {classes, maxItemsDisplayed} = this.props
    return (
      <div className={classes.root}>
        <Downshift
          onChange={sessionId => this.props.onChange(sessionId)}
        >
          {({getInputProps, getItemProps, isOpen, highlightedIndex}) => (
            <div className={classes.container}>
              {this.renderInput({
                fullWidth: true,
                InputProps: getInputProps({
                  ...this.props.InputProps
                }),
                ref: node => {this.popperNode = node}
              })}
              <Popper
                anchorEl={this.popperNode}
                open={isOpen}
                /* Below props are Required for Mobile Issues */
                disablePortal
                style={{ zIndex: 1000 }}
              >
                <Paper
                  style={{width: this.popperNode ? this.popperNode.clientWidth : null}}
                  square
                >
                  {this.props.items.map((item, index) => (
                    (!maxItemsDisplayed || index < maxItemsDisplayed) ?
                        this.renderItem({
                          classes,
                          highlightedIndex,
                          index,
                          item,
                          itemProps: getItemProps({item: item.sessionId}),
                        }) : null
                    ))}
                </Paper>
              </Popper>
            </div>
          )}
        </Downshift>
      </div>
    )
  }
}

Autocomplete.propTypes = {
  InputProps: PropTypes.object, // passed through to TextField component
  items: PropTypes.array,
  maxItemsDisplayed: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

export default withStyles(styles)(Autocomplete)


// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-case-id/Autocomplete.js